import MaskedTextField from '@map/components/Form/components/MaskedTextField';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do MaskedTextField
 */
export default styled(MaskedTextField)`
  .MuiInputBase-input {
    height: 18px;
    border-radius: 0;
    font-size: 12px;
    line-height: 14px;
    padding: 3px;
  }
  .MuiInputBase-inputAdornedEnd {
    padding-right: 15px;
  }
  .MuiInputAdornment-positionEnd {
    position: absolute;
    right: 4px;
    top: 9px;
    p {
      font-size: 12px !important;
    }
  }
`;
